
import { Vue, Component } from 'vue-property-decorator';
import { ChartData } from 'chart.js';
import { Transits } from '@/features/dashboard/types';
import LabelsList, { LabelItemType } from '@/features/dashboard/components/widgets/LabelsList.vue';
import NoContent from '@/features/dashboard/components/widgets/NoContent.vue';

@Component({
  components: {
    LabelsList,
    NoContent,
  },
})
export default class Content extends Vue {
  private colors: Array<string> = ['#623ec7', '#ffa43c', '#cb0f51', '#2bc5cb'];

  private noDataColor = '#e6e6eb';

  private chartKey = 'ChartKey'

  private labels: Array<string> = [
    'Created',
    'In Transit',
    'Exception',
    'Delivered',
  ]

  get chartData(): ChartData {
    // should rerender chart when data is loaded
    this.chartKey = `${this.chartKey}-${Date.now()}`;

    const data = {
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.hasData ? this.colors : this.noDataColor,
          data: this.hasData ? Object.values(this.transits) : [100],
          borderWidth: 0,
        },
      ],
    };
    return data;
  }

  get labelsData(): Array<LabelItemType> {
    return Object.entries(this.transits).map((el): LabelItemType => {
      const [key, val] = el;
      return {
        name: this.$t(`transitStatus.${key}`) as string,
        qty: val,
      };
    });
  }

  get hasData(): boolean {
    return this.transits && Object.values(this.transits).some((val) => val > 0);
  }

  get transits(): Transits {
    return this.$store.getters.getTransits;
  }

  get totalQty(): number {
    return this.hasData ? Object.values(this.transits).reduce((acc, el) => acc + el) : 0;
  }

  private handleLinkClick = (name: string) => {
    const queryParam = name.replace(/\s/g, '');
    this.$router.push(`/history?status=${queryParam}`);
  }
}
